export default {
	name: 'subjectSet',
	data() {
		return {
			Subjects: [],
			SubjectID: 0,
			SubjectName: '',
			SubjectDesc: '',
			Edit: '',
			clear: {}
		};
	},
	created() {
		this.getData = function() {
			this.$request.request({
				url: 'Shops/getUsers',
				data: {
					ShopID: this.$store.state.user.ShopID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.Subjects = r.Subjects;
					this.$store.commit('setSubjects', r.Subjects);
				}

			});
		}
		this.clear = () => {
			this.Edit = '';
			this.SubjectID = 0;
			this.SubjectName = '';
			this.SubjectDesc = '';
		}

	},
	methods: {
		update(i) {
			this.Edit = 'update';
			this.SubjectID = i.SubjectID;
			this.SubjectName = i.SubjectName;
			this.SubjectDesc = i.SubjectDesc;

		},
		edit() {
			this.$request.request({
				url: 'Shops/editShopSubject',
				data: {
					SubjectID: this.SubjectID,
					SubjectName: this.SubjectName,
					SubjectDesc: this.SubjectDesc,
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.Subjects = r.Subjects;

					this.clear();
					this.$store.commit('setSubjects', r.Subjects);
				}

			});
		}
	},
	computed: {

	},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	},
	activated() {
		this.getData();
	},

	watch: {

	}


}
